var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapStartPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "-1 -1 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0422\\u043E\\u0447\\u043A\\u0430_\\u0430_\\u043D\\u0430_\\u043A\\u0430\\u0440\\u0442\\u0456",
    "data-name": "\\u0422\\u043E\\u0447\\u043A\\u0430 \\u0430 \\u043D\\u0430 \\u043A\\u0430\\u0440\\u0442\\u0456",
    transform: "translate(-38 -124)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(38 124)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M3542.759,13201.49H3536.6V13201c0-1.908-.007-5.234-.009-6.367l.018-.324a8.851,8.851,0,0,1-4.738-6.844,1.216,1.216,0,0,1,.262-1,1.309,1.309,0,0,1,.98-.471.909.909,0,0,1,.926.848,7.358,7.358,0,0,0,2.7,4.906v-.031a16.629,16.629,0,0,1,3.014-.275,6.638,6.638,0,0,1,2.887.486l.007.012.008.012a1.082,1.082,0,0,1,.291.166,7.01,7.01,0,0,1,1.9,2.711c.03.068.061.137.094.209l.011.023a5.111,5.111,0,0,1,.591,1.916,4.2,4.2,0,0,1-.651,1.773c-.059.107-.115.211-.166.309a7.05,7.05,0,0,1-1.969,2.426Zm-.32-6.881h0l.01,4.279a8.493,8.493,0,0,0,.55-.873c.16-.293.295-.6.432-.914.023-.055.04-.1.059-.158A7.8,7.8,0,0,0,3542.439,13194.609Zm-2.867-3.506a2.2,2.2,0,1,1,2.117-2.2A2.162,2.162,0,0,1,3539.572,13191.1Z",
    transform: "translate(-3488 -13056.491)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapStartPoint);
export default __webpack_public_path__ + "static/media/map_start_point.4b6dcba723da1c429b27c665a0037bda.svg";
export { ForwardRef as ReactComponent };